import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { TemplateForm, type TemplateFormData } from '../components/templates/TemplateForm';
import { useCreateTemplate } from '../hooks/useCreateTemplate';
import type { CreateTemplateRequest } from '../../lib/types/template.types';

export function TemplateCreate() {
  const navigate = useNavigate();
  const createMutation = useCreateTemplate();

  const handleSubmit = async (formData: TemplateFormData) => {
    try {
      const createData: CreateTemplateRequest = {
        name: formData.name,
        description: formData.description,
        category_id: formData.category_id,
        content: { blocks: formData.blocks },
        tags: formData.tags,
        is_favorite: formData.is_favorite,
      };

      await createMutation.mutateAsync(createData);

      // Navigate back to templates list on success
      navigate('/templates');
    } catch (error) {
      console.error('Failed to create template:', error);
      // Error is handled by React Query and displayed via toast/notification
    }
  };

  const handleCancel = () => {
    navigate('/templates');
  };

  return (
    <div className="min-h-screen bg-[#F5F5F5] pb-8">
      {/* Header */}
      <div className="bg-white shadow-sm sticky top-0 z-20">
        <div className="p-4">
          <div className="flex items-center gap-3 mb-4">
            <button
              onClick={handleCancel}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ArrowLeftIcon className="w-6 h-6 text-gray-600" />
            </button>
            <h1 className="text-xl font-semibold text-[#212121]">
              Create New Template
            </h1>
          </div>
        </div>
      </div>

      {/* Form Content */}
      <div className="max-w-4xl mx-auto p-4">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
          <TemplateForm
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isSubmitting={createMutation.isPending}
            submitLabel="Create Template"
          />
        </div>
      </div>
    </div>
  );
}
